import React from 'react';
import './ServicesSection.css';
import { Link } from 'react-router-dom';
import { FaArrowRight } from 'react-icons/fa';
import airportImage from '../assets/services/airport.jpg';
import parcelImage from '../assets/services/parcel.jpg';
import schoolImage from '../assets/services/school.jpg';
import skiImage from '../assets/services/ski.jpg';
import wheelchairImage from '../assets/services/wheelchair.jpg';
import medicalImage from '../assets/services/medical.jpg';

function ServicesSection() {
  const services = [
    { 
      title: 'Courses Scolaires',
      description: 'Transport sécurisé pour les élèves',
      image: schoolImage,
      path: '/services/courses-scolaires'
    },
    { 
      title: 'Navette Aéroport',
      description: 'Transferts vers tous les aéroports',
      image: airportImage,
      path: '/services/navette-aeroport'
    },
    { 
      title: 'Stations de Ski',
      description: 'Transport vers les stations de ski',
      image: skiImage,
      path: '/services/stations-ski'
    },
    { 
      title: 'Transport de Colis',
      description: 'Livraison rapide et sécurisée',
      image: parcelImage,
      path: '/services/transport-colis'
    },
    { 
      title: 'Transport Médical',
      description: 'Transport adapté pour rendez-vous médicaux',
      image: medicalImage,
      path: '/services/transport-medical'
    },
    { 
      title: 'Mobilité Réduite',
      description: 'Véhicules adaptés et assistance',
      image: wheelchairImage,
      path: '/services/mobilite-reduite'
    }
  ];

  return (
    <div className="services-section">
      <div className="services-container">
        <div className="services-header">
          <h2>Nos Services</h2>
          <p>Des solutions de transport adaptées à tous vos besoins avec un service personnalisé</p>
        </div>
        <div className="services-grid">
          {services.map((service, index) => (
            <div className="service-card" key={index}>
              <Link to={service.path}>
                <div className="service-image">
                  <img src={service.image} alt={service.title} />
                </div>
                <div className="service-info">
                  <h3>{service.title}</h3>
                  <p>{service.description}</p>
                  <div className="service-link">
                    Découvrir <FaArrowRight />
                  </div>
                </div>
              </Link>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default ServicesSection;
